import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import AvatarMenu from 'components/AvatarMenu';
import ClientNavMenu from './ClientNavMenu';

import logo from '../../assets/thalo_logo.png';

import './TopNav.scss';

const TopNav = ({ currentClient }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { from } = location.state || {};
	const handleLogoClick = () => {
		navigate('/events', { state: { from: 'TopNav' } });
	};
	const handleClientClick = () => {
		navigate('/clients');
	};

	const clientsRoute = location && location.pathname && location.pathname === '/clients';
	const clientName =
		currentClient && currentClient.name && currentClient.id !== 1 && !clientsRoute ? (
			<span className="client-name" onClick={handleClientClick}>
				{currentClient.name}
			</span>
		) : null;

	const animateClass = from === 'Login' ? 'animate-in' : '';

	return (
		<div className={`TopNav ${animateClass}`}>
			<div className="left">
				<img src={logo} onClick={handleLogoClick} className="logo" alt="thalo logo" />
				{clientName}
			</div>
			<div className="right">
				{currentClient && <ClientNavMenu />}
				<AvatarMenu />
			</div>
		</div>
	);
};

const msp = ({ clients }) => ({
	currentClient: clients.currentClient,
});

const mdp = () => ({});

export default connect(msp, mdp)(TopNav);
